// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cz2.cz2 .cz2__ai-preview-modal-content{padding:32px;max-width:450px;display:flex;flex-direction:column;text-align:center}#cz2.cz2 .cz2__ai-preview-modal-content .cz2__ai-preview-modal-image{height:270px;width:100%;background-size:contain;background-position:50%;background-repeat:no-repeat}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
